/**
 * Application-owned visual tokens. These intentionally do not mirror the MUI
 * palette: shared components consume this vocabulary directly so page-level
 * overrides cannot drift from the product's visual language.
 */
export const visualTokens = {
  accentMint: "#00DEA3",
  actionBlue: "#3E73A4",
  actionGreen: "#00815E",
  danger: "#B42318",
  dangerHover: "#8F1D14",
  ink: "#1F4970",
  surfaceAction: "#EAF6FF",
  surfaceDisabled: "#DCEEFF",
  surfaceMint: "rgba(0, 222, 163, 0.2)",
  textOnDark: "#FFFFFF",
} as const;

export const accessibleInteractiveColors = {
  actionBlue: visualTokens.actionBlue,
  actionGreen: visualTokens.actionGreen,
  dangerTextOnTint: visualTokens.danger,
  successTextOnTint: "#0A7900",
  navigationBlue: "#3E73A4",
  secondaryText: "#566477",
  statusComplete: "#24833B",
  statusOverdue: "#C62828",
  statusPending: "#566477",
} as const;
